import React from 'react'
import imageImage from '../images/image2.webp';
import globeImage from '../images/start.webp';
import indImage from '../images/india-map.svg';
import mapImage from '../images/mapdubai.webp';
import singImage from '../images/singapore-map (1).svg';
import ContactForm from './ContactForm'
import OurTeam from './OurTeam'
import SeoHelmet from './SeoHelmet';

const ContactUs = () => {
  return (
    <div className='contactUs'>
      <SeoHelmet
        title="Contact Web5Solution"
        description="Start your next blockchain, AI, automation, or metaverse project with Web5Solution. Contact our team to discuss requirements and delivery timelines."
        path="/contact"
      />
      <div className='form-div'>
        <div className='globe-div'> 
            <h3>Have a project in mind?</h3>
  
            <div className='globe-img'>
            <img src={globeImage} alt=''/>
            </div>
            
        </div>
<div className=''>
    <ContactForm/>
</div>
      </div>
      <div className='map-div'>
      <div className='mapdubai2'>
      <svg xmlns="http://www.w3.org/2000/svg" width="369" height="427" viewBox="0 0 369 427" fill="none">
        <path d="M368 426V79.7248L286.112 1H1V426H368Z" stroke="#22A8B3"/>
      </svg>
      <div className='mapdubai-container'>
      <img src={indImage} alt='' className='mapImage' style={{marginTop:"20px"}}/>
      <div className='map-details'>
        <h5>India</h5>
      </div>
      </div>

    </div>
        <div className='mapdubai2'>
      <svg xmlns="http://www.w3.org/2000/svg" width="369" height="427" viewBox="0 0 369 427" fill="none">
        <path d="M368 426V79.7248L286.112 1H1V426H368Z" stroke="#22A8B3"/>
      </svg>
      <div className='mapdubai-container'>
      <img src={singImage} alt='' className='mapImage'/>
      <div className='map-details'>
        <h5>Singapore</h5>
      </div>
      </div>

    </div>
        <div className='mapdubai2'>
      <svg xmlns="http://www.w3.org/2000/svg" width="369" height="427" viewBox="0 0 369 427" fill="none">
        <path d="M368 426V79.7248L286.112 1H1V426H368Z" stroke="#22A8B3"/>
      </svg>
      <div className='mapdubai-container'>
      <img src={mapImage} alt='' className='mapImage'/>
      <div className='map-details'>
        <h5>Dubai</h5>
      </div>
      </div>

    </div>
      </div>
      
      <OurTeam/>
      {/* <ServiceInternalPage/> */}
    </div>
  )
}

export default ContactUs
